import { Banner } from '@legalzoom/ui/negroni';

export function UnsafePassword({ onDismiss }: { onDismiss: () => void }) {
  return (
    <Banner onDismiss={onDismiss} variant="error" className="mb-6">
      This password is not safe. Please choose a stronger, more unique password.
    </Banner>
  );
}
